export default [
  {
    name: "test-drives",
    meta: {
      title: "Test Drives",
      sort: 0,
      authenticatable: true,
      description: "Test Drives",
      permission: false,
      icon: "mdi-speedometer",
    },
  },
  {
    name: "test-drives-units",
    meta: {
      title: "Test Drive Units",
      sort: 0,
      authenticatable: true,
      description: "Test Drives",
      permission: false,
      icon: "mdi-car-outline",
      roles: ["admin"],
    },
  },
];
